export default "__VITE_ASSET__da0c62d8__"